import React, { Component } from 'react';

import Banner from './Banner';
import InfoCarrera from './InfoCarrera';
import OpcionesCarrera from './OpcionesCarrera';
import SubItem1 from './SubItem1';
import SubItem2 from './SubItem2';
import SubItem3 from './SubItem3';
import Pensum from './Pensum';
import Footer from '../Index/Footer';

class DiseñoGrafico extends Component {
    constructor (props) {
        super (props);
        this.scrollIni();
    }

    scrollIni = () => {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }

    scroll = (id) => (e) => {
        window.scroll({
            top: (document.getElementById(id).offsetTop) - 40,
            behavior: 'smooth'
        });
    }
    
    render() {
        return(
            <div style={{paddingLeft:0, paddingRight: 0,}}>
                <Banner/>
                {/* <InfoCarrera/> */}
                <OpcionesCarrera funcion = {(idItem) => this.scroll(idItem)}/>
                <SubItem1/>
                <SubItem2/>
                <SubItem3/>
                {/* <Pensum/> */}
                <Footer/>
            </div>
        );
    }
}
 
export default DiseñoGrafico;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoGrafico/DiseñoGrafico.jsx